export function hasRole (state, getters) {
	return (clubId, role) => getters[`getById`](clubId)?.userRoles?.some(
		userRole => userRole.role === role
	) || false;
}
